import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import TailoredProductImage from './TailoredProductImage'

const copy = {
  heading: `Create a tailored product recommendation engine`,
}

const list = [
  {
    title: `Synthesize`,
    description: `Tie your digital data with your internal systems to provide visibility around conversion rates.`,
  },
  {
    title: `Drive`,
    description: `Use individualized data to drive the behaviors or product features that increase customer loyalty and engagement.`,
  },
  {
    title: `Build`,
    description: `Build recommendation engines using machine learning powered by good data.`,
  },
]

const link = {
  text: `Explore Twilio Engage`,
  url: `/product/twilio-engage/`,
}

const TailoredProduct: FC<PropsWithChildren<unknown>> = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <SectionBase variant="2Col">
        <SectionCopy>
          <CopyTextBase>
            <StyledCopyTextHeading tag="h2">{copy.heading}</StyledCopyTextHeading>
            <ColumnTrack>
              {list.map(({ title, description }, index) => (
                <FeatureBoxBase key={index} alignment="left">
                  <FeatureBox.Body>
                    <FeatureBox.Title>{title}</FeatureBox.Title>
                    <FeatureBox.Text>{description}</FeatureBox.Text>
                  </FeatureBox.Body>
                </FeatureBoxBase>
              ))}
            </ColumnTrack>
            <CopyText.Link href={getAbsoluteUrl(link.url, pageConfig)}>{link.text}</CopyText.Link>
          </CopyTextBase>
        </SectionCopy>

        <StyledSectionContents>
          <TailoredProductImage />
        </StyledSectionContents>
      </SectionBase>
    </Wrapper>
  )
}

const StyledSectionContents = styled(Section.Contents)`
  align-self: center;
`

const StyledCopyTextHeading = styled(CopyText.Heading)`
  margin-bottom: 40px;
`

const Wrapper = styled.div`
  display: grid;
`

const SectionCopy = styled(Section.Copy)`
  display: flex;
  align-items: center;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    max-width: 392px;
    justify-self: end;
    align-self: center;
  }
`

export default TailoredProduct
